// User-selected illustrative amounts; not approved terms or eligibility categories.
export const CHEQUE_SIZES = Object.freeze([
  {amount: 1000000, display: 10, unit: 'lakh'},
  {amount: 2500000, display: 25, unit: 'lakh'},
  {amount: 5000000, display: 50, unit: 'lakh'},
  {amount: 10000000, display: 1, unit: 'crore'},
  {amount: 20000000, display: 2, unit: 'crore'},
  {amount: 50000000, display: 5, unit: 'crore'},
].map(Object.freeze));